module.exports = __webpack_public_path__ + "img/ymkjbanner1.27aca424.png";